const form = {
  formId: "new-user-form",
  formField: {
    taxpayers: {
      name: "taxpayers",
      label: "[04] Tên người nộp thuế:",
      type: "text",
      placeholder: "Người nộp thuế",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxCode: {
      name: "taxCode",
      label: "[05] Mã số thuế:",
      type: "text",
      placeholder: "Mã số thuế",
      errorMsg: "Vui lòng nhập mã số thuế",
    },
    taxAgentName: {
      name: "taxAgentName",
      label: "[06] Tên đại lý thuế (nếu có):",
      type: "text",
      placeholder: "Đại lý thuế",
      errorMsg: "Vui lòng nhập tên đại lý thuế",
    },
    taxAgentCode: {
      name: "taxAgentCode",
      label: "[07] Mã số thuế đại lý:",
      type: "text",
      placeholder: "Mã số thuế đại lý",
      errorMsg: "Vui lòng nhập mã số thuế đại lý",
    },
    //
    capitalTransfer: {
      name: "capitalTransfer",
      label: "Chuyển nhượng vốn",
      type: "text",
      errorMsg: "",
    },
    transferofsharePurchaseRights: {
      name: "transferofsharePurchaseRights",
      label: "Chuyển nhượng quyền mua cổ phần",
      type: "text",
      errorMsg: "",
    },
    differentAgreedMethod: {
      name: "differentAgreedMethod",
      label: "Khác phương thức thỏa thuận",
      type: "text",
      errorMsg: "",
    },
    agreedMethod: {
      name: "agreedMethod",
      label: "Theo phương thức thỏa thuận",
      type: "text",
      errorMsg: "",
    },
    transferOfCapitalContributionRights: {
      name: "transferOfCapitalContributionRights",
      label: "Chuyển nhượng quyền góp vốn",
      type: "text",
      errorMsg: "",
    },
    from: {
      name: "from",
      label: "Tại doanh nghiệp",
      type: "text",
      errorMsg: "",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "",
    },
    mst: {
      name: "mst",
      label: "Mã số thuế",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập mã số thuế",
    },
    strangeFrom: {
      name: "strange",
      label: "[01] Kỳ tính: từ",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính",
    },
    strangeTo: {
      name: "strange",
      label: "đến",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính",
    },
    time: {
      name: "time",
      label: "[03] Bổ sung lần thứ: ",
      type: "number",
      placeholder: "1",
      errorMsg: "Vui lòng chọn số lần bổ sung",
    },
    //
    chiefAccountant: {
      name: "chiefAccountant",
      label: "Họ và tên:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên nhân viên đại lý thuế",
    },
    certificateNumber: {
      name: "certificateNumber",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số chứng chỉ hành nghề",
    },
    unitHeads: {
      name: "unitHeads",
      label: "Người ký:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên người ký",
    },
    dateFounded: {
      name: "dateFounded",
      label: "Ngày ký:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
